import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as ShareLinkIcon } from 'assets/icons/share_link_outline.svg';
import { ReactComponent as VenngageLogoIcon } from 'assets/icons/venngage_logo.svg';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { DesignMessageProps, MessageType } from '../Chat.types';

/**
 * Render the infographic design in the ChatPanel
 *
 * @param data.messages[0] base infographic template ID
 * @param data.messages[1] user prompt
 */
export const DesignMessage = memo(({ data, onUpdate }: DesignMessageProps) => {
  const { t } = useTranslation('design_generator', { keyPrefix: 'messages.design' });
  const handleOnClick = useCallback(() => {
    onUpdate(MessageType.DESIGN, 'click', data);
  }, [data, onUpdate]);

  const ChatDesignMessageTestId = 'chat-design-message';

  return (
    <Flex flexDirection='column' data-testid={ChatDesignMessageTestId}>
      <Flex gap='4'>
        <Flex alignItems='flex-end'>
          <VenngageLogoIcon width='24px' height='24px' color='var(--vg-colors-brand-500)' />
        </Flex>
        <Flex
          p='2'
          borderRadius='lg'
          bg='violet.50'
          justifyContent='space-between'
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <Flex
            w='408px'
            minW='408px'
            h='full'
            alignItems='center'
            justifyContent='center'
            onClick={handleOnClick}
            overflow='hidden'
            cursor='pointer'
            aria-label={t('button')}
          >
            {data.children}
          </Flex>
          <Flex
            flexBasis={{ base: 'unset', md: 56 }}
            alignItems='center'
            justifyContent={{ base: 'left', md: 'center' }}
            pl='2'
            py='2'
          >
            <Button
              variant='ghost'
              size='xs'
              display='flex'
              flexDirection='row'
              alignItems='center'
              onClick={handleOnClick}
              aria-label={t('button')}
            >
              <Text as='span' fontSize='xs' fontWeight='medium' fontFamily='Inter'>
                {t('button')}
              </Text>
              <Box width='4' height='4' ml='2'>
                <ShareLinkIcon />
              </Box>
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
});

DesignMessage.displayName = 'DesignMessage';
